// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1i8_U","savePackageButton":"ClientWallet_savePackageButton__30o4b"};